import type { SidePanel } from '../types';

export const RequisiteAdd: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./RequisiteAddForm.vue')),
};
